module.exports = __webpack_public_path__ + "img/f72004f83d_5fe1cbf2d4.54ae2337.webp";